import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
} from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";

const AddCuisine = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    user_id: "",
    cuisine_type: "",
    url: "",
    created_at: "",
    updated_at: "",
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure required fields are provided
    if (!formData.user_id || !formData.cuisine_type || !formData.url) {
      setError("Please provide all required fields.");
      return;
    }

    try {
      const response = await fetch(` ${API_URL}/cuisine/cuisinefiller`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.ok) {
        setSuccess(result.message);
      } else {
        setError(result.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error adding recipe:", error);
      setError("Error adding recipe, try again later.");
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Add Cuisines
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              label="User ID"
              variant="outlined"
              fullWidth
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Cuisine Type"
              variant="outlined"
              fullWidth
              name="cuisine_type"
              value={formData.cuisine_type}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="URL"
              variant="outlined"
              fullWidth
              name="url"
              value={formData.url}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Created At"
              type="datetime-local"
              variant="outlined"
              fullWidth
              name="created_at"
              value={formData.created_at}
              onChange={handleChange}
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Updated At"
              type="datetime-local"
              variant="outlined"
              fullWidth
              name="updated_at"
              value={formData.updated_at}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              startIcon={<CloudUploadIcon />}
            >
              Add Cuisine
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* Success/Error Snackbar */}
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        message={error}
      />
      <Snackbar
        open={!!success}
        autoHideDuration={6000}
        onClose={() => setSuccess(null)}
        message={success}
      />
    </Box>
  );
};

export default AddCuisine;
